var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dowloadurl"},[_c('van-cell-group',{attrs:{"title":"下载链接"}},_vm._l((_vm.urls),function(item){return _c('van-cell',{key:item.url,attrs:{"title":item.title,"value":item.title,"is-link":true,"url":item.url}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }